import { createOrder } from '../../_meta/order';

export const createReturnedOrder = () => createOrder();

export default {};
